handleOrderError